import { useState } from 'react';
import { getDynamicEnvVarsInClient } from '@/utils/envHelper';
import axios from 'axios';
import { toast } from 'sonner';

const useForgotPassword = (emailTemplateId: number) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>('');
  const [error, setError] = useState<string>('');

  const { NEXT_PUBLIC_API_URL } = getDynamicEnvVarsInClient();

  const handleClick = async (
    email: string,
    tenantId: string,
    clientId: string,
    redirecturl: string,
    postParent: boolean
  ) => {
    if (email && tenantId && clientId) {
      setError('');
      setLoading(true);
      try {
        const url = NEXT_PUBLIC_API_URL;
        const res = await axios.post(`${url}/forgot-password`, {
          email: email?.toLowerCase(),
          tenantId,
          clientId,
          emailTemplateId,
          redirecturl,
          postParent,
        });
        if (res.data) {
          setData(res.data);
        }
      } catch (error: any) {
        const axiosError = error;
        if (axiosError.response) {
          setError(axiosError?.response?.data?.message || 'An error occurred');
        } else if (axiosError.request) {
          setError('Request failed, please try again later');
        } else {
          setError('An error occurred, please try again later');
        }
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Email and tenant id is required');
    }
  };

  return {
    loading,
    handleClick,
    data,
    error,
  };
};

export default useForgotPassword;
